import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  StatCard,
  ContentCard,
  DashboardHeader,
  Icons,
} from "../common/DashboardComponents";
import Loader from "../common/Loader";
import {
  fetchGrants,

  fetchGrantsBySection
} from "../../redux/actions/grievanceActions1";

// Import grant list configuration
import {
  getStatusOptions,
  getSchemeOptions,
  getFilteredGrants,
  getGrantStats,
  getGrantListTitle,
  getTableColumns,
  GRANT_STATUS,
} from "../common/GrantListConfig";

const GrantList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Redux state
  const {
    grants,
    loading: grantsLoading,
   
  } = useSelector((state) => state.grievances);

  console.log(grants, 'grantssssss');
  

  // User role - default to Branch (3)
  const [userRole, setUserRole] = useState(3);

  // Filter and pagination states
  const [filteredGrants, setFilteredGrants] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [schemeFilter, setSchemeFilter] = useState("all");
  const [isPendingAt, setIsPendingAt] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [grantsPerPage, setGrantsPerPage] = useState(10);

  // Load user role from localStorage
  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      if (userData && userData.role) {
        setUserRole(userData.role);
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
  }, []);

  // Check for isPendingAt parameter in URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isPendingAtParam = urlParams.get('isPendingAt');
    
    if (isPendingAtParam) {
      setIsPendingAt(decodeURIComponent(isPendingAtParam));
    }
  }, []);


  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      if (!userData) return;

      if (userData.role === 10) {
        dispatch(fetchGrantsBySection(userData.UNIT_CENTRE_ID));
      } else {
        dispatch(fetchGrants());
      }
    } catch (error) {
      console.error("Error loading grants:", error);
    }
  }, [dispatch]);

  // Get role-based filtered grants
  const roleFilteredGrants = useMemo(() => {
    return getFilteredGrants(userRole, grants);
  }, [userRole, grants]);

  // Apply filters (search term, status, scheme)
  useEffect(() => {
    if (roleFilteredGrants.length === 0) return;

    let result = [...roleFilteredGrants];

    // Filter by status (match GrievanceList.js logic)
    if (statusFilter !== "all") {
      result = result.filter((g) => g.STATUS_NAME === statusFilter);
    }

    // Filter by scheme
    if (schemeFilter !== "all") {
      result = result.filter((g) => g.GRANT_TYPE === schemeFilter);
    }

    // Filter by pending role
    if (isPendingAt) {
      result = result.filter((g) => g.PENDING_ROLE_NAME === isPendingAt);
    }

    // Filter by search term
    if (searchTerm) {
      const searchTermLower = searchTerm.toLowerCase();
      result = result.filter(
        (grant) =>
          grant.APP_ID?.toString().toLowerCase().includes(searchTermLower) ||
          grant.USER_NAME?.toLowerCase().includes(searchTermLower) ||
          grant.REMARKS?.toLowerCase().includes(searchTermLower) ||
          grant.GRANT_TYPE?.toLowerCase().includes(searchTermLower)
      );
    }

    setFilteredGrants(result);
    setCurrentPage(1); // Reset to first page whenever filters change
  }, [roleFilteredGrants, searchTerm, statusFilter, schemeFilter, isPendingAt]);

  // Handle filter changes
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleSchemeFilterChange = (e) => {
    setSchemeFilter(e.target.value);
  };

  const handleItemsPerPageChange = (e) => {
    setGrantsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // Get role-specific configuration
  const statusOptions = getStatusOptions(userRole, grants);
  const schemeOptions = getSchemeOptions(grants);
  const grantStatCards = getGrantStats(userRole, grants);
  const tableTitle = getGrantListTitle(userRole);
  const tableColumns = getTableColumns(userRole, navigate);

  // Pagination logic
  const indexOfLastGrant = currentPage * grantsPerPage;
  const indexOfFirstGrant = indexOfLastGrant - grantsPerPage;
  const currentGrants = filteredGrants.slice(
    indexOfFirstGrant,
    indexOfLastGrant
  );
  const totalPages = Math.ceil(filteredGrants.length / grantsPerPage);

  // Pagination methods
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);
  const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  // Pagination logic helper for ellipsis-style pagination
  function getPagination(current, total) {
    const delta = 2; // how many pages to show around current
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  }

  return (
    <div className="container-fluid">
      <DashboardHeader title="Grant Management" />

      {/* Statistics Cards */}
      <div className="stats-grid">
        {grantStatCards.map((stat, index) => (
          <StatCard
            key={index}
            // title={stat.title}
            title={'Total Grants'}
            value={stat.value}
            icon={stat.icon}
            color={stat.color}
            additionalInfo={
              stat.additionalInfo ? <span>{stat.additionalInfo}</span> : null
            }
          />
        ))}
      </div>

      {/* Filters */}
      <ContentCard title="Filters" icon={Icons.Filter}>
        <div className="row">
          <div className="col-md-3 mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search grants..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          <div className="col-md-3 mb-3">
            <select
              className="form-select"
              value={statusFilter}
              onChange={handleStatusFilterChange}
            >
              {statusOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3 mb-3">
            <select
              className="form-select"
              value={schemeFilter}
              onChange={handleSchemeFilterChange}
            >
              {schemeOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3 mb-3">
            <div className="d-flex align-items-center">
              <label className="me-2">Items per page:</label>
              <select
                className="form-select form-select-sm w-auto"
                value={grantsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
              </select>
            </div>
          </div>
        </div>
      </ContentCard>

      {/* Grant List */}
      <ContentCard title={tableTitle} icon={Icons.Grants}>
        {grantsLoading ? (
          <Loader message="Loading grants..." />
        ) : (
          <>
            <div className="table-responsive">
              <table className="table border-top border-bottom">
                <thead className="bg-light">
                  <tr>
                    {tableColumns.map((column, index) => (
                      <th className="py-3" key={index}>
                        {column.header}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {currentGrants.length === 0 ? (
                    <tr>
                      <td
                        colSpan={tableColumns.length}
                        className="text-center py-4"
                      >
                        No grants found
                      </td>
                    </tr>
                  ) : (
                    currentGrants.map((grant, index) => (
                      <tr
                        key={`grant_${grant.APP_ID}_${index}`}
                        className="border-bottom"
                      >
                        {tableColumns.map((column, colIndex) => (
                          <td className="py-3" key={colIndex}>
                            {column.render(grant)}
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {filteredGrants.length > 0 && (
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="text-muted">
                  Showing {indexOfFirstGrant + 1} to {Math.min(indexOfLastGrant, filteredGrants.length)} of {filteredGrants.length} entries
                </div>
                <nav aria-label="Grant pagination">
                  <ul className="pagination mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>
                    {getPagination(currentPage, totalPages).map((page, idx) =>
                      page === "..." ? (
                        <li key={idx} className="page-item disabled">
                          <span className="page-link">…</span>
                        </li>
                      ) : (
                        <li
                          key={idx}
                          className={`page-item ${currentPage === page ? "active" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(page)}
                            style={currentPage === page ? { border: "1px solid #000" } : {}}
                          >
                            {page}
                          </button>
                        </li>
                      )
                    )}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={nextPage}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </>
        )}
      </ContentCard>
    </div>
  );
};

export default GrantList;